const PRODUCT_TYPE_ACTION_TYPES = {
  LOAD_PRODUCT_TYPE: 'type/LOAD_PRODUCT_TYPE',
};

export default PRODUCT_TYPE_ACTION_TYPES;
